import { TicketAllocation } from '@app-types/ticketSales';

export function isManualSalesEditable(row: TicketAllocation): boolean {
  return row.canModifyAdjustments === true;
}

export function sortAllocations<T extends { ticketCompany: string; ticketName: string }>(allocations: T[]): T[] {
  return [...allocations].sort((a, b) => {
    const byCompany = a.ticketCompany.localeCompare(b.ticketCompany);
    return byCompany !== 0 ? byCompany : a.ticketName.localeCompare(b.ticketName);
  });
}

function calculatePercentSold(allocation: number | null, totalSales: number | null): number | null {
  if (allocation === null || totalSales === null || !Number.isFinite(allocation) || !Number.isFinite(totalSales)) {
    return null;
  }

  return allocation > 0 ? Math.round((totalSales / allocation) * 100) : 0;
}

// TODO: resolve this calculations with actual Calculator
export function withRecalculatedSales(row: TicketAllocation, manualSales: number): TicketAllocation {
  const totalSales = Number(row.feedSales) + manualSales;
  const percentSold = calculatePercentSold(row.allocation, totalSales);

  return {
    ...row,
    manualSales,
    totalSales,
    percentSold,
    unsold: row.allocation === null ? null : row.allocation - totalSales,
  };
}

function sumValues(values: Array<number | null | undefined>): number | null {
  const knownValues = values.filter(
    (value): value is number => value !== null && value !== undefined && Number.isFinite(value),
  );

  if (knownValues.length === 0) {
    return null;
  }

  return knownValues.reduce((total, value) => total + value, 0);
}

export function sumAllocationTotals(rows: TicketAllocation[]) {
  const totals = {
    allocation: sumValues(rows.map((row) => row.allocation)),
    feedSales: sumValues(rows.map((row) => row.feedSales)),
    manualSales: sumValues(rows.map((row) => row.manualSales)),
    totalSales: sumValues(rows.map((row) => row.totalSales)),
    unsold: sumValues(rows.map((row) => row.unsold)),
  };

  return {
    ...totals,
    percentSold: rows.some((row) => row.unsold !== null && row.unsold !== undefined && Number.isFinite(row.unsold))
      ? calculatePercentSold(totals.allocation, totals.totalSales)
      : null,
  };
}
